/**
 * GTM dataLayer helpers.
 * event_id MUSI byc identyczny z server-side CAPI
 * (registration-conversion.service.ts: `app-registration-<userId>`) —
 * Meta dedupuje pixel vs CAPI po parze (event_name, event_id).
 */

type AccountCreatedPush = {
  event: "account_created";
  event_id: string;
  signup_method: "email_password" | "google_oauth";
  user_email: string;
};

declare global {
  interface Window {
    // Musi byc zgodne z deklaracja w pages/sales.tsx (TS2717 przy rozjezdzie).
    dataLayer?: unknown[];
  }
}

export function pushAccountCreated(params: {
  userId: string;
  email: string;
  signupMethod: "email_password" | "google_oauth";
}): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const payload: AccountCreatedPush = {
    event: "account_created",
    event_id: `app-registration-${params.userId}`,
    signup_method: params.signupMethod,
    user_email: params.email,
  };
  window.dataLayer.push(payload);
}
